import { type User } from '../model/types';

export function getUserType(user: User) {
    if (user.isAdmin) {
        return 'Администратор';
    }
    if (user.user_type === 'client') {
        return 'Клиент';
    }
    if (user.user_type === 'agent') {
        return 'Агент';
    }
    if (user.user_type === 'supplier') {
        return 'Поставщик';
    }
    if (user.user_type === 'leasing') {
        return 'Лизинг';
    }
    return user.user_type ?? 'Пользователь';
}